import { render, staticRenderFns } from "./AddOrUpdatePatientModal.vue?vue&type=template&id=a078e0da&"
import script from "./AddOrUpdatePatientModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdatePatientModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdatePatientModal.vue?vue&type=style&index=0&id=a078e0da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports